import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { SpecraDivider } from '../ensigns/divider';
import { SpecraEyebrow } from '../ensigns/eyebrow';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraNavigationItemView } from './navigation-item';
/** Labeled group of related program navigation items. */ export function SpecraNavigationGroupView({ className, collapsed = false, collapsible = false, containsActive = false, group, labelTestId, onToggle, open = true, renderLink, separated = false, ...props }) {
    const showItems = collapsed || !collapsible || open;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(separated && (collapsed ? 'mt-3 pt-3' : 'mt-4'), className),
        "data-group-id": group.id,
        ...props,
        children: [
            separated && collapsed ? /*#__PURE__*/ _jsx(SpecraDivider, {
                className: "mb-3"
            }) : null,
            !collapsed && group.label ? collapsible ? /*#__PURE__*/ _jsxs("button", {
                "aria-expanded": open,
                className: cn('flex w-full cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 text-left transition-colors hover:bg-accent/70', !open && containsActive ? 'text-foreground' : 'text-muted-foreground/70 hover:text-foreground', specraFocusRing),
                "data-testid": labelTestId,
                onClick: onToggle,
                type: "button",
                children: [
                    /*#__PURE__*/ _jsx(SpecraEyebrow, {
                        className: "pointer-events-none min-w-0 flex-1 truncate text-inherit",
                        children: group.label
                    }),
                    open ? /*#__PURE__*/ _jsx(ChevronDown, {
                        "aria-hidden": "true",
                        className: "size-3 shrink-0 opacity-70"
                    }) : /*#__PURE__*/ _jsx(ChevronRight, {
                        "aria-hidden": "true",
                        className: "size-3 shrink-0 opacity-70"
                    })
                ]
            }) : /*#__PURE__*/ _jsx(SpecraEyebrow, {
                className: "px-2 pb-1 text-muted-foreground/70",
                children: group.label
            }) : null,
            showItems ? /*#__PURE__*/ _jsx("div", {
                className: "space-y-0.5",
                children: group.items.map((item)=>/*#__PURE__*/ _jsx(SpecraNavigationItemView, {
                        collapsed: collapsed,
                        item: item,
                        renderLink: renderLink
                    }, item.id))
            }) : null
        ]
    });
}
